import { createFileRoute } from '@tanstack/react-router';
import { GatewayPage } from '@/pages/GatewayPage';
export const Route = createFileRoute('/gateway')({
    component: GatewayPage,
});
//# sourceMappingURL=gateway.js.map